import React, { useEffect } from 'react'
import ApplicantSideBar from '../../components/ApplicantSideBar'
import TopNavigation from '../../layouts/top-navigation/TopNavigation'
import NewApplicant from '../Applicants/NewApplicants'
import ApplicantDropouts from './ApplicantDropouts'
import ApplicantEvaluation from './ApplicantEvaluation'
import ApplicantHired from './ApplicantHired'
import ApplicantOffered from './ApplicantOffered'
import ApplicantScreening from './ApplicantScreening'
import ActiveInterview from '../Interview/ActiveInterview'
import { useActive } from './ActiveProvider'
import { useAppDispatch, useAppSelector } from '../../useStore'
import { applicantDashboardData, reset } from '../../features/Applicant/applicantSlice'
import InterviewHistory from '../Interview/InterviewHistory'
import Tranning from '../Tranning/Tranning'
import BottomNavigation from '../../layouts/bottom-navigation/BottomNavigation'


interface Props {
  setActive: string;
}

const Applicants: React.FC<Props> = () => {
  const dispatch = useAppDispatch();
  const { active, setActive } = useActive();


  const {
    EvalvationisSuccess,
    UpdateScreeningStatusisSuccess,
    sendOfferisSuccess,
    applicationInterviewisSuccess,
    updateApplicationInterviewStatusisSuccess,
    sendEmailisSuccess,
    shareApplicationisSuccess,
    ScreeningisSuccess,
    applicationassignedisSuccess,
    scheduleApplicantisSuccess,
    updateInterviewStatusisSuccess,
    applicantDashboardDatadata,
    dropoutToScreeningisSuccess,
    isSuccess,
    UpdateOfferisSuccess,
    sendForHireisSuccess
  } = useAppSelector((state: { applicant: any }) => state.applicant);

  useEffect(() => {
    if (
      EvalvationisSuccess ||
      UpdateScreeningStatusisSuccess ||
      sendOfferisSuccess ||
      applicationInterviewisSuccess ||
      updateApplicationInterviewStatusisSuccess ||
      sendEmailisSuccess ||
      shareApplicationisSuccess ||
      ScreeningisSuccess ||
      applicationassignedisSuccess ||
      scheduleApplicantisSuccess ||
      updateInterviewStatusisSuccess ||
      dropoutToScreeningisSuccess ||
      isSuccess ||
      UpdateOfferisSuccess ||
      sendForHireisSuccess
    ) {
      dispatch(applicantDashboardData());
      setTimeout(() => {
        dispatch(reset());
      }, 2000);
    }
  }, [
    UpdateOfferisSuccess,
    isSuccess,
    dropoutToScreeningisSuccess,
    EvalvationisSuccess,
    UpdateScreeningStatusisSuccess,
    sendOfferisSuccess,
    applicationInterviewisSuccess,
    updateApplicationInterviewStatusisSuccess,
    sendEmailisSuccess,
    shareApplicationisSuccess,
    ScreeningisSuccess,
    applicationassignedisSuccess,
    scheduleApplicantisSuccess,
    updateInterviewStatusisSuccess,
    sendForHireisSuccess,
    dispatch
  ]);


  useEffect(() => {
    dispatch(applicantDashboardData());
  }, [dispatch]);






  return (
    <div id="screen-wrapper">
      <TopNavigation />
      <ApplicantSideBar setActive={setActive} active={active} data={applicantDashboardDatadata} />
      <BottomNavigation />
      <main>
        {active === 0 && <NewApplicant />}
        {active === 1 && <ApplicantScreening />}
        {active === 2 && <ApplicantEvaluation />}
        {active === 3 && <ActiveInterview />}
        {active === 4 && <InterviewHistory />}
        {active === 5 && <ApplicantOffered />}
        {active === 6 && <Tranning />}
        {active === 7 && <ApplicantHired />}
        {active === 8 && <ApplicantDropouts />}
      </main>
    </div>
  );
}

export default Applicants 